import DocumentWatermarkApi from '../../core/apis/DocumentWatermarkApi';
import { fontColors } from './DocumentWatermarkLookups';
import { isValueStartingWithBlank } from '../../core/utils/index';

// event.currentTarget.style.backgroundColor returns an RGB color,
// we're converting it to the same hex format that is used in other parts of Watermark components
const convertColorToHex = rgb => {
  var rgbSplit = rgb.split('(')[1].split(')')[0];
  rgbSplit = rgbSplit.split(',');
  var hex = rgbSplit.map(x => {
    x = parseInt(x)
      .toString(16)
      .toUpperCase();
    return x.length === 1 ? '0' + x : x;
  });
  hex = '#' + hex.join('');
  return hex;
};

// prepare the fontColor field for the API
const convertFontColorFromHexToString = hex => {
  let fontColor = 'BLACK'; // default value

  // not using map() here, since it creates an array, which we don't need
  fontColors.forEach(color => {
    if (color.code === hex) {
      fontColor = color.name;
    }
  });

  return fontColor;
};

/**
 * Converting string we get in response to the same hex format that is used in other Watermark components.
 * By doing so, we avoid two types of issues:
 *   1) discrepancies in react-admin's representation of color names as opposed to hex values we're using
 *   when color names are used for button's backgroundColor property (colors are darker than those offered in the color picker),
 *   2) if we make some changes on the Edit screen, but don't change the color, color name would be parsed to convertFontColorFromHexToString
 *   and that conversion would fail.
 * Another solution for the second (more critical) issue would be to have a flag that would keep track of
 * whether the user changed the color or not, but keeping all colors in the same hex (#) format seems like a better approach.
 */
const convertHexColorFromStringToHex = responseColor => {
  let fontColor = '#000000'; // default value

  // not using map() here, since it creates an array, which we don't need
  fontColors.forEach(color => {
    if (color.name === responseColor) {
      fontColor = color.code;
    }
  });

  return fontColor;
};

/*
 * Form level validation.
 * Verify that preset name is unique
 */
const validateWatermarkName = async values => {
  const errors = {};
  if (isValueStartingWithBlank(values.profileName)) {
    errors.profileName = 'Name cannot start with blank characters.';
  } else {
    const nameExists = await DocumentWatermarkApi.checkNameExists(
      values.profileName
    );
    if (nameExists) {
      errors.profileName = 'Watermark profile with this name already exists.';
    }
  }
  return errors;
};

const getFormatFromValues = (isBoldSelected, isItalicSelected) => {
  return isBoldSelected
    ? isItalicSelected
      ? 'BOLD_AND_ITALICS'
      : 'BOLD'
    : isItalicSelected
    ? 'ITALICS'
    : 'NOT_SET';
};

export {
  convertColorToHex,
  convertFontColorFromHexToString,
  convertHexColorFromStringToHex,
  validateWatermarkName,
  getFormatFromValues
};
